/* ============================================================
   ORION CART EXTRAS — small fixes to third-party widgets in the drawer.

   SavedBy Checkout+: the widget renders inside an open shadow root on
   <savedby-checkout-plus>, so theme CSS cannot reach it. Its "Checkout+"
   title is hidden by adopting a stylesheet into that root. The fee line
   ("100% Satisfaction Guarantee · $3.47") stays: the checkout button
   itself carries the fee, so the customer must still see what it is for.
   The cleaner switch is SavedBy's own admin (Storefront > info title).
   ============================================================ */
(() => {
  const CSS = '.sb__info-text-container > span[name="title"] { display: none !important; }';
  let sheet = null;
  const getSheet = () => {
    if (sheet) return sheet;
    try { sheet = new CSSStyleSheet(); sheet.replaceSync(CSS); } catch (e) { sheet = null; }
    return sheet;
  };

  function patch(host) {
    const root = host.shadowRoot;
    if (!root || root.__orionPatched) return;
    const s = getSheet();
    if (s) {
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, s];
    } else {
      const style = document.createElement('style');
      style.textContent = CSS;
      root.appendChild(style);
    }
    root.__orionPatched = true;
  }

  const scan = () => document.querySelectorAll('savedby-checkout-plus').forEach(patch);

  function init() {
    scan();
    // the drawer re-renders on every cart change and SavedBy remounts with it
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
